import React, { useEffect } from 'react';
import { View, Text, StyleSheet, ActivityIndicator } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import type { StackNavigationProp } from '@react-navigation/stack';
import type { RootStackParamList } from '../types/navigation';
import { FullLogo } from '../components';
import { colors, spacing, fontWeights } from '../theme';

type NavigationProp = StackNavigationProp<RootStackParamList, 'M01SplashScreen'>;

export const M01SplashScreen: React.FC = () => {
  const navigation = useNavigation<NavigationProp>();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigation.replace('M02LoginScreen');
    }, 2000);
    return () => clearTimeout(timer);
  }, [navigation]);

  return (
    <View style={styles.container}>
      <View style={styles.logoContainer}>
        <FullLogo width={280} />
      </View>
      <View style={styles.footer}>
        <ActivityIndicator size="small" color={colors.primary} />
        <Text style={styles.footerText}>Đang tải dữ liệu...</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#ffffff',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing[6],
  },
  logoContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  title: {
    fontFamily: "'Be Vietnam Pro', sans-serif",
    fontSize: 36,
    fontWeight: fontWeights.bold,
    color: colors.primary,
    marginTop: spacing[4],
  },
  subtitle: {
    fontSize: 16,
    color: colors.onSurfaceVariant,
    marginTop: spacing[2],
  },
  footer: {
    alignItems: 'center',
    marginBottom: spacing[10],
  },
  footerText: {
    fontSize: 12,
    color: colors.onSurfaceVariant,
    marginTop: spacing[2],
  },
});
